import React from "react";
import CloudHero from "./cloudHero/CloudHero";
import CloudConsulting from "./cloudConsulting/CloudConsulting";
import CloudTestimonial from "./cloudTestimonial/CloudTestimonial";
import CloudInnovation from "./cloudInnovation/CloudInnovation";
import CloudBenefits from "./cloudBenefits/CloudBenefits";
import CloudGrowth from "./cloudGrowth/CloudGrowth";
import CloudIndustry from "./cloudIndustry/CloudIndustry";
import CloudService from "./cloudService/CloudService";

export default function Cloud() {
  return (
    <div id="cloud">
      <CloudHero />
      <CloudConsulting />
      <CloudInnovation />
      <CloudBenefits />
      <CloudIndustry />
      <CloudGrowth />
      <CloudTestimonial />
      <CloudService />
    </div>
  );
}
